<template>
<div class="chapter">
<div class="inner_page">
<h2 class="center" id="note" style="margin-top:50px;">Author’s Note</h2>
<p class="noind" style="margin-top:30px;"><i>Tapestry</i> is a work of fiction. Though I have used actual places and times, I have treated these as I have seen fit, changing some as appropriate. Occasionally the name of a real person is used for historical authenticity, but all are deceased and I have made of them what the story demands. I do not condone what happened during these times. Indeed, I abhor it. But during the Occupation of France everyday crimes of murder and arson continued to be committed, and I merely ask, by whom and how were they solved?</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 7-note.vue?58421323